import type { MEALS } from '../constants';

export type MealType = (typeof MEALS)[number]['mealType'];

/**
 * i18n key for the empty-slot "add a meal" button.
 *
 * The button text carries the meal name itself ("Ajouter un déjeuner") rather
 * than pairing a fixed-width uppercase kicker with a bare "+". That kicker was
 * clipped to 56px, which wrapped "DÉJEUNER" onto two lines (#530) — folding the
 * name into the sentence removes the fixed column entirely.
 *
 * Explicit per-meal sentences rather than `Ajouter un {{meal}}` interpolating
 * `thisWeek.mealTypes.*`: those values are capitalized nouns ("Déjeuner",
 * "Breakfast"), so interpolation yields "Ajouter un Déjeuner" / "Add
 * Breakfast", and French would additionally need the article to agree with the
 * noun. A full sentence per meal keeps every locale grammatical.
 */
export function addMealLabelKey(mealType: MealType): string {
  switch (mealType) {
    case 'breakfast':
      return 'weekly.addBreakfast';
    case 'lunch':
      return 'weekly.addLunch';
    case 'dinner':
      return 'weekly.addDinner';
  }
}
